import moment from 'moment';

export function getCurrentDate() {
    return moment.now();
}

export function formatDate(date) {
    if(!date){
        return moment().format('MMM-Do-YY');
    }
    return moment(date).format('MMM-Do-YY');
}

export function formatToDateTime(date) {
    return moment(date).format('YYYY-MM-DD');
}

export function formatDateAndTime(date) {
    return moment(date).format(" MMMM Do YYYY, hA");
}

export function getDuration(date) {
    return moment(date).fromNow();
}